export const appMethods = [
  'reload',
  'tellAboutException',
  'processBulkTitoOperation',
  'rfidRegisterMode',
  'getPlayerInfo',
  'startCollectDepositMoney',
  'finishCollectDepositMoney',
  'getDepositRecords',
  'printDepositTicketById',
  'checkOneTimeLoginBarcode',
  'printOneTimeLoginTickets',
  'getWithdrawalRequests',
  'validateWithdrawalPin',
  'payWithdrawalRequest',
  'printOneTimePassword',
  'adminUserCommands',
  'getDailyReport',
  'lastEnteredBillsAndCoinsFormatted',
  'printTicket',
  'printBetBuilderTicket',
  'titoAcceptCasinoBet',
  'printBookingTicket',
  'casinoGamesPageOpened',
  'printClientTicket',
  'printLotteryTickets',
  'getLastTicketById',
  'getSuperbetTicketById',
  'setSuperBetId',
  'endVerifiedLoginSession',
  'rejectSuperbet',
  'setTax',
  'printLastPayedTickets',
  'setType',
  'withdraw',
  'withdrawPartial',
  'withdrawWithFee',
  'withdrawClientBalance',
  'setSecondScreenUrl',
  'userDidLogin',
  'userDidLogout',
  'registerMode',
  'inspectElement',
  'openLastLogFile',
  'openDmsLastTicketDialog',
  'openAdminPage',
  'titoAcceptBet',
  'titoCashoutBet',
  'titoAcceptCashout',
  'titoAcceptBoPayment',
  'confirmUserId',
  'confirmDeposit',
  'cancelBillAcceptor',
  'getCurrency',
  'appReady',
  'lockTerminal',
  'isAdminLoggedIn',
  'cardRegistered',
  'isCardRegistered',
  'confirmRegistrationNewCard',
  'updatePlayerCardId',
  'upperScreen',
  'unlockTerminal',
  'stackerCollection',
  'setBalance',
  'titoCashoutBetFromTicketsBoard',
  'adminPageWasOpened',
  'printLastTicket',
  'printDailyReport',
  'printLastCashoutTicket',
  'printLastPaidTickets',
  'getLastPaidTicketsWithDetails',
  'logoutUser',
  'stackerBalance',
  'getLastTickets',
  'getLastPaidTickets',
  'getLastPaidTicketsByDateRange',
  'todaysReport',
  'multipleDaysReport',
  'resetBillAcceptor',
  'showDeviceStatuses',
  'checkHoppersErrorsAndStates',
  'calibration',
  'hopper1Refill',
  'writeLog',
  'hopper2Refill',
  'resetDeviceConnections',
  'lastEnteredBillsAndCoins',
  'scanBarcode',
  'shutDown',
  'rebootPC',
  'closeApplication',
  'loginAdmin',
  'exitAdmin',
  'setIdle',
  'setNotIdle',
  'setVirtualVideo',
  'adminPageExit',
  'openTerminalIdDialog',
  'touchPosition',
  'resetUiByIdleTimer',
  'cardDeposit',
  'loginAdmin',
  'showStackerBalance',
  'depositToClientAccount',
  'sendLogs',
  'bulkTitoOperation',
  'setLanguage',
  'getMerchantInfo',
  'setPlayerPaymentInfo',
  'resetPlayerPaymentInfo',
  'manageMoneyInput',
  'setLastMoneyInputType',
  'getBetPlayerPaymentInfoBulk',
  'increaseLocalBalanceOnNonCashInput',
  'savePlayerPaymentInfo',
  'getSavedPlayerPaymentInfo'
]